import { styled } from "@mui/material";
import Button, { ButtonProps as MuiButtonProps } from "@mui/material/Button";
import { FC } from "react";
import { TIconNames } from "src/shared/types/iconNames";
import Icon from "../IconComponent";

export interface IIconButtonProps
  extends Omit<MuiButtonProps, "startIcon" | "endIcon" | "children"> {
  iconName: TIconNames;
  rounded?: boolean;
}

const shouldForwardProp = (prop: string): boolean => prop !== "rounded";

const StyledButton = styled(Button, { shouldForwardProp })<{
  rounded?: boolean;
}>(({ theme, ...buttonProps }) => {
  const getPadding = () => {
    switch (buttonProps?.size) {
      case "small":
        return buttonProps.variant === "outlined"
          ? theme?.spacing(1.5)
          : theme?.spacing(1.75);

      case "large":
        return buttonProps.variant === "outlined"
          ? theme.spacing(1.75)
          : theme.spacing(2);

      default:
        return buttonProps.variant === "outlined"
          ? theme.spacing(1.75)
          : theme.spacing(2);
    }
  };
  const getFontSize = () => {
    switch (buttonProps?.size) {
      case "small":
        return 14;

      case "large":
        return 20;

      default:
        return 16;
    }
  };

  return {
    padding: getPadding(),
    ...(buttonProps.rounded ? { borderRadius: "100%" } : {}),
    minWidth: 0,
    flexShrink: 0,
    fontSize: getFontSize(),
  };
});

export const IconButton: FC<IIconButtonProps> = ({
  iconName,
  rounded = true,
  ...buttonProps
}) => {
  return (
    <StyledButton {...buttonProps} rounded={rounded} color="inherit">
      <Icon iconname={iconName} />
    </StyledButton>
  );
};
